import Magnetic from "@/components/Magnetic";
import { useLang } from "@/i18n/LanguageContext";

export default function Footer({ onNavigate }) {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="border-t border-[#1A1A1A] px-6 md:px-12 py-10 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between">
      <span className="font-display text-2xl uppercase text-[#E5E5E5]">Chloé Rigallaud-Leal</span>
      <div className="flex flex-wrap gap-8 font-mono-tech text-[10px] tracking-[0.25em] text-[#808080] uppercase">
        <span>{t("footer.loc")}</span>
        <span>{t("footer.role")}</span>
      </div>
      <Magnetic>
        <button
          data-testid="back-to-top-button"
          onClick={() => onNavigate("#top")}
          className="font-mono-tech text-[10px] tracking-[0.3em] text-[#808080] hover:text-[#75FB4E] uppercase transition-colors duration-300 block px-2 py-1"
        >
          {t("footer.backToTop")}
        </button>
      </Magnetic>
    </footer>
  );
}
